// Client-side notify helper. Fires a notification via send-lr-direct-notification edge fn.
// Replaces direct supabase.from("notifications").insert + ad-hoc email invokes.
// Always fire-and-forget — never blocks the calling UI.
import { supabase } from "@/integrations/supabase/client";

export interface ClientNotifyArgs {
  recipientUserId: string;
  eventType: string;          // notificationEvents.ts key
  inAppType: string;          // notifications.type
  title: string;
  body: string;
  link?: string | null;
  loadId?: string | null;
  metadata?: Record<string, unknown>;
  smsBody?: string;
  emailPayload?: Record<string, unknown>;
  skipInApp?: boolean;        // skip notification row insert (when DB trigger already wrote it)
}

export function notifyClient(args: ClientNotifyArgs): Promise<void> {
  return supabase.functions.invoke("send-lr-direct-notification", {
    body: {
      recipient_user_id: args.recipientUserId,
      event_type: args.eventType,
      in_app_type: args.inAppType,
      title: args.title,
      body: args.body,
      link: args.link ?? null,
      load_id: args.loadId ?? null,
      metadata: args.metadata ?? {},
      sms_body: args.smsBody,
      email_payload: args.emailPayload,
      skip_in_app: args.skipInApp === true,
    },
  }).then(
    () => {},
    (e) => { console.warn("notifyClient failed", args.eventType, e); },
  );
}

